import { select, takeEvery } from 'redux-saga/effects';

import { STEP_CHANGE } from '../routing/flowModule';
import {
    SAVE_NEW_ITEM,
    ITEM_IS_REMOVED,
    ITEM_UNDO_REMOVE
} from '../item/itemModule';
import { getStorefrontSessionKey } from '../session/sessionSelectors';

import { getBaseEventProperties, getAnalyticsName } from './segmentSelectors';
import { trackPage, trackEvent } from './segment';



export function* sendRoutingEvent({ path, sessionID }) {
    const name = getAnalyticsName(path);

    if (name) {
        const baseProperties = yield select(getBaseEventProperties, sessionID);
        const segmentProperties = {
            name,
            properties: { ...baseProperties }
        };
        trackPage(name, segmentProperties, { context: { ip: '0.0.0.0' } });
    }
}


export function* sendTrackingEvent(action, data) {
    const baseProperties = yield select(getBaseEventProperties);
    const preexistingDataProperties = data.properties || {};
    data.properties = { ...baseProperties, ...preexistingDataProperties };
    trackEvent(action, data, { context: { ip: '0.0.0.0' } });
}


export function* sendSegment(action) {
    const { eventAction, eventData } = action.meta.segment;
    const sessionID = yield select(getStorefrontSessionKey);
    switch (action.type) {
        case SAVE_NEW_ITEM: {
            eventData.cart_id = sessionID;
            yield sendTrackingEvent(eventAction, eventData);
            break;
        }
        case ITEM_IS_REMOVED: {
            eventData.cart_id = sessionID;
            yield sendTrackingEvent(eventAction, eventData);
            break;
        }
        case ITEM_UNDO_REMOVE: {
            eventData.cart_id = sessionID;
            yield sendTrackingEvent(eventAction, eventData);
            break;
        }
        default:
            yield sendTrackingEvent(eventAction, eventData);
    }
}


export const takeGeneralPattern = action => ((action.meta || {}).segment !== undefined);


export function* segmentWatcher() {
    yield takeEvery(takeGeneralPattern, sendSegment);
    yield takeEvery(STEP_CHANGE, sendRoutingEvent);
}
